import { Component } from "react";
import { FaChevronDown, FaUser, FaUserCog, FaSignOutAlt, FaShoppingBasket, FaLink, FaAngleDown, FaFileAlt, FaGlobe, FaUserTie, FaUserPlus } from "react-icons/fa";
import { withRouter } from "react-router";

import {
  Container,
  NavbarToggler,
  Collapse,
  NavItem,
  Navbar,
  Nav,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Col,
  Row,
} from "reactstrap";
import { Link } from "react-router-dom";
import update from "immutability-helper";
import logo from "../images/icon/nahibu-navbar.webp";
import WaitingDiv from "./waiting";
import { withTranslation } from "react-i18next";
import i18n from "i18next";
import LanguageSelector from "./navbar/languageselector";
import Cookies from "universal-cookie";
import axios from "axios";
import CartIcon from "./navbar/carticon";

class NahibuNavbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false, // State to manage the visibility of the navbar (for mobile view)
      isAffiliated: false, // State to check if the user is affiliated
      productDropdown: false, // State to manage the product dropdown visibility
      isMobile: window.innerWidth <= 768, // Detect if the screen is mobile-sized
    };
    this.toggle = this.toggle.bind(this);
    this.toggleProduct = this.toggleProduct.bind(this);
    this.close = this.close.bind(this);
    this.logout = this.logout.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  // Event listener to handle window resizing
  componentDidMount() {


    i18n.on('languageChanged', () => {
      this.forceUpdate(); // Re-render the component when language changes
    });
    window.addEventListener("resize", this.updateWindowDimensions);

    // Check if user is affiliated via API
    const cookies = new Cookies();
    const user = cookies.get("user");
    const requestUrlAff = this.props.config.mybioteUrl + "/api/v1/is_affiliated/";
    const axiosParams = {
      headers: {
        Authorization: this.props.config.tokenAffiliatesViewer,
      },
    };

    if (user) {
      let data = {
        email: user.email,
      };
      axios.post(requestUrlAff, data, axiosParams)
        .then((result) => {
          if (result.data) {
            this.affiliate();
          }
        })
        .catch((error) => console.log(error));
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
    i18n.off('languageChanged');
  }

  updateWindowDimensions() {
    this.setState({ isMobile: window.innerWidth <= 768 });
  }

  // Toggle function to open/close the navbar
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  // Toggle function to open/close the product dropdown
  toggleProduct() {
    this.setState({
      productDropdown: !this.state.productDropdown,
    });
  }

  // Function to close both the navbar and product dropdown
  close() {
    this.setState({
      isOpen: false,
      productDropdown: false,
    });
  }

  // Logout function to remove the user cookie and redirect to the home page
  logout() {
    const cookies = new Cookies();
    cookies.remove("user", { path: "/", domain: this.props.config.cookieDomain });
    this.props.setStateRoot(
      {
        auth: update(this.props.auth, {
          waiting: { $set: false }, // Set waiting state to false
          user: { $set: {} }, // Clear user data
          logged: { $set: false }, // Set logged state to false
        }),
      },
      () => {
        this.props.history.push("/"); // Redirect to home page
      }
    );
  }

  // Function to set the user as affiliated
  affiliate() {
    this.setState({
      isAffiliated: true,
    });
  }

  get langSubPath() {
    const language = i18n.language
      ? i18n.language.startsWith("fr")
        ? "fr"
        : i18n.language.startsWith("en")
          ? "en"
          : "es"
      : undefined;
    return language === "en" ? "/en" : language === "es" ? "/es" : "";
  }


  render() {
    const t = this.props.t;

    // Determine the language
    const language = i18n.language
      ? i18n.language.startsWith("fr")
        ? "fr"
        : i18n.language.startsWith("en")
          ? "en"
          : "es"
      : undefined;

    // Login link for logged in users
    let loggedLink = (
      <NavItem>
        <Link onClick={this.close} className="btn-analyse" to={this.langSubPath + "/" + t("path|login") + "/"}>
          <FaUser style={{ transform: 'translateY(-2px)' }} /> <span className="underline-hover">{t("navbar|Connexion")}</span>
        </Link>
      </NavItem>
    );

    // Login link for logged in users PHONE
    let loggedLinkPhone = (
      <Link onClick={this.close} className="nav-link ml-1 p-0 pl-3 mr-3" title={t("navbar|Se connecter / S’inscrire")} to={this.langSubPath + "/" + t("path|login") + "/"}>
        <FaUserPlus className="" style={{ transform: 'translateY(-2px)' }} size={24} />
      </Link>
    );

    // Account dropdown for logged in users
    let accountDropdown = (
      <DropdownMenu right>
        <DropdownItem>
          <WaitingDiv waiting={this.props.auth.waiting} />
        </DropdownItem>
      </DropdownMenu>
    );

    if (!this.props.auth.waiting) {
      accountDropdown = (
        <DropdownMenu>
          <DropdownItem className="pl-1">
            <a
              onClick={this.close}
              target="_blank"
              rel="noreferrer"
              className="nav-link"
              href={this.state.isAffiliated
                ? this.props.config.mybioteUrl + "/plateformeb2b/home"
                : this.props.config.mybioteUrl + "/analysis/last"}
            >
              {this.state.isAffiliated ?
                <>
                  <FaUserTie size={20} className="mr-2 fix-icon-pad" />
                  {"Nahibu PRO"}
                </>
                :
                <>
                  <FaFileAlt size={20} className="mr-2 fix-icon-pad" />
                  {t("navbar|Mes analyses")}
                </>
              }
            </a>
          </DropdownItem>
          <DropdownItem className="pl-1">
            <Link onClick={this.close} className="nav-link" to={this.langSubPath + "/" + t("path|orders") + "/"}>
              <FaShoppingBasket size={20} className="mr-1 fix-icon-pad" /> {t("navbar|Mes commandes")}
            </Link>
          </DropdownItem>
          <DropdownItem className="pl-1">
            <a
              onClick={this.close}
              target="_blank"
              rel="noreferrer"
              className="nav-link"
              href={this.props.config.mybioteUrl}
            >
              <FaLink size={20} className="mr-1 fix-icon-pad" /> {t("navbar|Relier mon kit")}
            </a>
          </DropdownItem>
          <DropdownItem divider />
          <DropdownItem className="pl-1">
            <Link onClick={this.close} className="nav-link" to={this.langSubPath + "/" + t("path|account") + "/"}>
              <FaUserCog size={20} className="mr-1 fix-icon-pad" /> {t("navbar|Paramètres")}
            </Link>
          </DropdownItem>
          <DropdownItem className="pl-1">
            <Link onClick={this.logout} to="/" className="nav-link">
              <FaSignOutAlt size={20} style={{ color: "#bb0000" }} className="mr-1 fix-icon-pad" /> {t("navbar|Se déconnecter")}
            </Link>
          </DropdownItem>
        </DropdownMenu>
      );
    }

    if (this.props.auth.logged) {
      loggedLink = (
        <NavItem >
          <a
            onClick={this.close}
            target="_blank"
            rel="noreferrer"
            className="btn-analyse"
            href={
              this.state.isAffiliated
                ? this.props.config.mybioteUrl + "/plateformeb2b/home"
                : this.props.config.mybioteUrl + "/analysis/last"
            }
          >
            <span className="underline-hover">
              {this.state.isAffiliated ?
                <>
                  <FaUserTie className="mr-1" style={{ transform: 'translateY(-2px)' }} />{"Nahibu PRO"}
                </>
                :
                <>
                  <FaFileAlt className="mr-1" style={{ transform: 'translateY(-2px)' }} />{t("navbar|Mes analyses")}
                </>
              }
            </span>
          </a>
        </NavItem>
      );
      loggedLinkPhone = (

        <a
          onClick={this.close}
          target="_blank"
          rel="noreferrer"
          className="nav-link mx-3 p-0"
          href={
            this.state.isAffiliated
              ? this.props.config.mybioteUrl + "/plateformeb2b/home"
              : this.props.config.mybioteUrl + "/analysis/last"
          }
        >

          {this.state.isAffiliated ?
            <FaUserTie size={20} style={{ transform: 'translateY(-2px)' }} />
            :
            <FaFileAlt size={20} style={{ transform: 'translateY(-2px)' }} />}
        </a>

      );
    }

    return (
      <Navbar light className="shadow-sm fixed-top gradiant-bot-gray" expand="md">
        <Container fluid className="d-flex justify-content-between align-items-center">

          <Row className="d-md-none align-items-center w-100">
            {/* Logo startup Nahibu */}
            <Col xs="2" className="justify-content-start d-flex p-0">
              <Link onClick={this.close} to={this.langSubPath + "/"} className="navbar-brand pl-3 pl-3">
                <img alt={t("navbar|Nahibu startup rennaise")} src={logo} className="navbar-image" />
              </Link>
            </Col>

            {/* Section visible uniquement sur mobile: Menu Hamburger, LanguageSelector, et Icone Panier */}

            <Col xs="10" className="d-flex justify-content-end align-items-center p-0">
              {this.props.auth.logged && (
                <UncontrolledDropdown inNavbar>
                  <DropdownToggle nav className="mb-1 p-0 mr-3">
                    <FaUser size={18} />
                    <FaChevronDown size={9} />
                  </DropdownToggle>

                  {accountDropdown}
                </UncontrolledDropdown>

              )}


              <Link onClick={this.close} className="nav-link mb-1 p-0 mr-3 ml-2" to={this.langSubPath + "/" + t("path|panier") + "/"}>
                <CartIcon number={this.props.cartNumber} waiting={this.props.waitingCart} config={this.props.config} />
              </Link>


              <div className="d-md-none d-block">
                {loggedLinkPhone}
              </div>

              <NavbarToggler className="ml-2 px-1" onClick={this.toggle} />
            </Col>

          </Row>

          {/* Section visible uniquement sur les écrans plus larges */}

          {/* Logo startup Nahibu */}
          <div className="d-none d-md-block">
            <Link onClick={this.close} to={this.langSubPath + "/"} className="navbar-brand pl-3 pl-3">
              <img alt={t("navbar|Nahibu startup rennaise")} src={logo} className="navbar-image" />
            </Link>
          </div>
          <div className="d-none d-md-flex">
            <NavbarToggler onClick={this.toggle} className="ml-auto" />
          </div>

          <Collapse
            isOpen={this.state.isOpen}
            navbar
            className={this.state.isOpen ? "navbar-collapse-open" : "navbar-collapse-closed"}
          >
            <Nav className="mx-auto" navbar>
              <NavItem>
                <Link onClick={this.close} className="nav-link nav-bold" to={this.langSubPath + "/"}>
                  {t("navbar|Accueil")}
                </Link>
              </NavItem>
              <NavItem>
                <Link onClick={this.close} className="nav-link nav-bold" to={{ pathname: `${this.langSubPath}/${t("path|produits")}` }}>
                  {t("navbar|Produits")}
                </Link>
              </NavItem>

              <NavItem>
                <Link onClick={this.close} className="nav-link nav-bold" to={this.langSubPath + "/" + t("path|faq") + "/"}>
                  {t("navbar|FAQ")}
                </Link>
              </NavItem>



              <NavItem>
                <a
                  onClick={this.close}
                  href="https://blog.nahibu.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="nav-link nav-bold"
                >Blog
                </a>
              </NavItem>


              <NavItem>
                <Link onClick={this.close} className="nav-link nav-bold" to={this.langSubPath + "/" + t("path|contact") + "/"}>
                  {t("navbar|Contact")}
                </Link>
              </NavItem>


              {this.state.isMobile ? (
                <>
                  <NavItem>
                    <LanguageSelector style={{ fontWeight: "bold" }} lang={language} />
                  </NavItem>
                  <NavItem style={{ listStyle: "none" }}>
                    <a
                      onClick={this.close}
                      href="https://nahibu.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="nav-link small text-muted nahibucom"
                    ><FaGlobe style={{ transform: 'translateY(-2px)', marginRight: '4px' }} />Nahibu.com
                    </a>
                  </NavItem>
                </>
              ) : null}

              <div className="d-md-block d-none">
                {loggedLink}
              </div>


            </Nav>

            {/* Section visible uniquement sur les écrans plus larges */}
            <div className="d-none d-md-flex align-items-center">
              {this.props.auth.logged && (
                <UncontrolledDropdown inNavbar>
                  <DropdownToggle nav>
                    <FaUser size={19} />
                    <FaAngleDown />
                  </DropdownToggle>
                  {accountDropdown}
                </UncontrolledDropdown>
              )}
              <Link onClick={this.close} className="nav-link mx-2" to={this.langSubPath + "/" + t("path|panier") + "/"}>
                <CartIcon number={this.props.cartNumber} waiting={this.props.waitingCart} config={this.props.config} />
              </Link>
              <LanguageSelector lang={language} />
              <NavItem style={{ listStyle: "none" }}>
                <a
                  onClick={this.close}
                  href="https://nahibu.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="nav-link small text-muted dark-blue nahibucom"
                ><FaGlobe style={{ transform: 'translateY(-2px)', marginRight: '4px' }} />Nahibu.com
                </a>
              </NavItem>
            </div>
          </Collapse>
        </Container>
      </Navbar>
    );
  }
}

export default withTranslation()(withRouter(NahibuNavbar));
